import {Component, Input, OnInit} from '@angular/core';
import {
  Aangifte,
  AangifteRapport, BokkzAlgDataService, IncomeTaxEntity,
  OpbouwHeffingskortingen,
  SpecificatieHeffingskortingen
} from "@snelstart-ventures/fiscaal/domain-logic";
import {BokkzIbDataService} from "@snelstart-ventures/fiscaal/domain-logic";
import {AbstractControl, FormBuilder, FormControl, FormGroup} from "@angular/forms";
import { SelectFormControlItem, SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import {BehaviorSubject} from "rxjs";
import { SharedUiDetailsModule } from '@snelstart/ui-details';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-spec-heffingskortingen',
  templateUrl: './spec-heffingskortingen.component.html',
  styleUrls: ['./spec-heffingskortingen.component.scss'],
  imports: [
    SharedUiFormControlsModule,
    SharedUiDetailsModule,
    CommonModule
  ]
})
export class SpecHeffingskortingenComponent implements OnInit {
    @Input() public id!: string;
    public aangifte = {} as Aangifte;
    public incomeTaxEntity = {} as IncomeTaxEntity;

    @Input() partner = new BehaviorSubject<boolean>(false);
    private currentAangifte = {} as Aangifte;
    private partnerAangifte = {} as Aangifte;

    specHeffingskortingenFormGroup = this.fb.group<AangifteRapport>({});
    specHeffingskortingen = {} as AangifteRapport;

    public itemsJaNee: SelectFormControlItem<boolean>[] = [
        {value: true, label: "Ja"},
        {value: false, label: "Nee"}
    ];

    propertyNamesToCheck: string[] = [
        'algemeneHeffingskorting',
        'arbeidskorting',
        'inkomensafhankelijkeCombinatieKorting',
        'ouderenkorting',
        'alleenstaandeOuderenkorting',
        'wajong',
        'groeneBeleggingen',
        'levensloopverlof',
        'werkbonus',
        'vutkorting',
        'maximering',
        'verhogingPartner',
    ];

    propertyTextMap: Record<string, string> = {
        algemeneHeffingskorting: 'Algemene heffingskorting',
        arbeidskorting: 'Arbeidskorting',
        inkomensafhankelijkeCombinatieKorting: 'Inkomensafhankelijke combinatiekorting',
        ouderenkorting: 'Ouderenkorting',
        alleenstaandeOuderenkorting: 'Alleenstaande ouderenkorting',
        wajong: 'Jonggehandicaptenkorting',
        groeneBeleggingen: 'Korting voor groene beleggingen',
        levensloopverlof: 'Levensloopverlofkorting',
        werkbonus: 'Werkbonus',
        vutkorting: 'Vut-korting',
        maximering: 'Af: Maximering',
        verhogingPartner: 'Verhoging i.v.m. inkomen partner',
    };

    getPropertyValue(propertyName: string): number | null {
        const control = this.specHeffingskortingenFormGroup.get(['specificatieHeffingskortingen', 'opbouw', propertyName]);
        return control ? control.value : null;
    }

    constructor(public dataService: BokkzIbDataService, public dataAlgService: BokkzAlgDataService, private fb: FormBuilder) {
        this.specHeffingskortingenFormGroup = this.fb.group<AangifteRapport>(({
            specificatieHeffingskortingen: this.fb.group<SpecificatieHeffingskortingen>(({
                opbouw: this.fb.group<OpbouwHeffingskortingen>(({
                    algemeneHeffingskorting: null as unknown as number,
                    arbeidskorting: null as unknown as number,
                    inkomensafhankelijkeCombinatieKorting: null as unknown as number,
                    ouderenkorting: null as unknown as number,
                    alleenstaandeOuderenkorting: null as unknown as number,
                    wajong: null as unknown as number,
                    grondslagGroeneBeleggingen: null as unknown as number,
                    groeneBeleggingen: null as unknown as number,
                    levensloopverlof: null as unknown as number,
                    werkbonus: null as unknown as number,
                    vutkorting: null as unknown as number,
                    maximering: null as unknown as number,
                    verhogingPartner: null as unknown as number,
                    voldoetAanVoorwaardenUitbetalingAlgemeneHeffingskorting: '' as unknown as boolean,
                    voldoetAanVooraardenBijzondereVerhogingHeffingskorting: '' as unknown as boolean,
                } as OpbouwHeffingskortingen))
            } as SpecificatieHeffingskortingen))
        } as AangifteRapport))
    }

    public ngOnInit(): void {
        this.dataService.incomeTaxEntity.subscribe((incomeTaxEntity) => {
            this.incomeTaxEntity = incomeTaxEntity;
            if (incomeTaxEntity.aangifte) {
                const aangifte = incomeTaxEntity.aangifte as Aangifte;
                this.aangifte = aangifte;
                this.dataService.aangifteRapport.subscribe((value) => {
                    this.specHeffingskortingen = value;
                    this.specHeffingskortingenFormGroup.patchValue(this.specHeffingskortingen)
                });
            }
        });
    }

    disableFormGroup(formGroup: FormGroup | AbstractControl): void {
        if (formGroup instanceof FormGroup) {
            Object.keys(formGroup.controls).forEach((key) => {
                const control = formGroup.get(key);
                if (control instanceof FormControl) {
                    control.disable();
                } else if (control instanceof FormGroup) {
                    this.disableFormGroup(control);
                }
            });
        }
    }

}

